var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editPage"},[_c('qx-card',{attrs:{"title":_vm.pageTitle}},[_c('BaseForm',{ref:"baseForm",on:{"pwdDialogSuccess":_vm.sub,"checkPwdByMsgDialogSuccess":_vm.sub}})],1),_c('SubBtnBox',{on:{"sub":_vm.sub}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }